<template>
    <div class="loading-spinner">
        <div
            v-for="i in 6"
            :key="i"
            class="dot"
            :style="{
                transform: `rotate(${(i - 1) * 60}deg) translate(0, -10px)`
            }"
        />
    </div>
</template>

<script setup lang="ts">
defineOptions({ name: 'LoadingSpinner' });
</script>

<style scoped>
.loading-spinner {
    width: 30px;
    height: 30px;
    position: relative;
    animation: spin 2s linear infinite;
}

.dot {
    position: absolute;
    width: 5px;
    height: 5px;
    background-color: #666;
    border-radius: 50%;
    top: 50%;
    left: 50%;
    margin-left: -3px;
    margin-top: -3px;
}

@keyframes spin {
    0% {
        transform: rotate(0deg);
    }
    100% {
        transform: rotate(360deg);
    }
}
</style>
